import axios from 'axios'
import { Message } from 'iview'
import qs from 'qs'
import { TOKEN } from '@/const/localStorage'

const instance = axios.create({
  baseURL: 'https://dpay.s1yun.com/ljapi/', // https://bird.ioliu.cn/v1?url=
  timeout: 1000 * 60
});

instance.interceptors.request.use(function (config) {
  const token = localStorage.getItem(TOKEN)
  if (token) {
    config.headers['Authorization'] = JSON.parse(token)
  }
  return config
}, function (error) {
  return Promise.reject(error);
})

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  if (response.status === 200) {
    if ('code' in response.data) {
      if (response.data.code === 200) {
        return response.data.data;
      } else {
        Message.error(response.data.msg)
        return Promise.reject(response)
      }
    } else {
      return response.data
    }
  } else {
    return Promise.reject(response)
  }
}, function (error) {
  if ('response' in error && error.response) {
    if ('status' in error.response) {
      const { response } = error
  
      if (response.status === 401) {
        Message.error('登录验证过期，请重新登录！')
      } else {
        Message.error('接口响应错误，请联系管理员！' + error.message)  
      }
    }
    
  } else {
    // 对响应错误做点什么
    Message.error('接口响应错误，请联系管理员！' + error.message)  
  }
  
  
  return Promise.reject(error);
});

const adminInstance = axios.create({
  baseURL: 'https://dpay.s1yun.com/ljadmin/', // https://bird.ioliu.cn/v1?url=
  headers: {
    // 'content-type': 'application/x-www-form-urlencoded'
  },
  timeout: 1000 * 60
});

// 添加响应拦截器
adminInstance.interceptors.response.use(function (response) {
  if (response.status === 200) {
    if (response.data.code === 200) {
      return response.data.data;
    } else {
      return response.data
    }
  } else {
    return Promise.reject(response)
  }
}, function (error) {
  const { response } = error
  console.log(response);
    if (response.status === 401) {
      Message.error('登录验证过期，请重新登录！')
      return Promise.reject(error);
    }
  Message.error('接口响应错误，请联系管理员！' + error.message)  
  return Promise.reject(error);
});

adminInstance.interceptors.request.use(async function (config) {
  return config
}, function (error) {
  return Promise.reject(error);
})

export const get = (url, config = {}) => instance.get(url, config)

export const post = (url, data = {}, config = {}) => instance.post(url, data, config)

export const getAdmin = (url, config = {}) => adminInstance.get(url, config)

export const postAdmin = (url, data = {}, config = {}) => adminInstance.post(url, data, config)


// WEBPACK FOOTER //
// ./src/utils/https.js